import React from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';

interface SelectOption {
  value: string | number;
  label: string;
  disabled?: boolean; // Ajouter la propriété optionnelle disabled
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  name: string;
  register: UseFormRegister<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  options: SelectOption[];
  error?: FieldError;
}

const Select: React.FC<SelectProps> = ({ label, name, register, options, error, ...rest }) => {
  const selectId = `select-${name}`;
  return (
    <div className="mb-4">
      <label htmlFor={selectId} className="block text-sm font-medium text-foreground mb-1">
        {label}
      </label>
      <select
        id={selectId}
        {...register(name)}
        {...rest}
        className={`mt-1 block w-full pl-3 pr-10 py-2 text-base rounded-md border bg-background text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:text-sm ${error ? 'border-destructive' : 'border-input'}`}
        aria-invalid={error ? 'true' : 'false'}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-xs text-destructive">{error.message}</p>}
    </div>
  );
};

export default Select;
